import {Component, OnInit} from '@angular/core';
import {EnvironmentService, EnvironmentType, EnvironmentTypeShortNames} from "../../services/environment.service";

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {

  environment = EnvironmentType.Unknown;
  isExpanded = false;
  
  constructor(private _environmentService: EnvironmentService) {}

  ngOnInit(): void {
    this.environment = this._environmentService.GetEnvironmentType();
  }
  
  nonProdEnvironment() {
    return this.environment != EnvironmentType.Unknown
        && this.environment != EnvironmentType.Prod;
  }

  getEnvironmentName() {
    return EnvironmentTypeShortNames[this.environment];
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
